export const creditActivitySchema = {
    $id: 'urn:wisepipe-usages-domain:CreditActivity',
    type: 'object',
    properties: {
        isCreditReset: { type: 'boolean' },
        previousCredit: { type: 'number' },
        isBonusCredit: { type: 'boolean' }
    },
    required: []
};
//# sourceMappingURL=creditActivity.js.map